// extracted by mini-css-extract-plugin
module.exports = {"container":"iT2XUExw904Pmhj3n3G2L","groupsList":"_2OgOOxKO9mgHC8v4xb6Rdz"};